import React, { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { HashLink } from 'react-router-hash-link';
import DeadlineScrollBar from '../Deadline_ScrollBar/Deadline_ScrollBar';
import { useTranslation } from 'react-i18next';
import Footer from '../Footer/Footer';
import TermsData from './TermsConditionData';
import TermsDataFr from './TermsConditionDataFr';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
//import Link from '@material-ui/core/Link';
import { Container } from '@material-ui/core';
const TermsCondition = (props) => {
  const scrollWithOffset = (el) => {
    // const yCoordinate = el.getBoundingClientRect().top + window.offsetTop;
    // const yOffset = 100;
    // setTimeout(() => {
    window.scrollTo({
      top: document.body.offsetHeight + 100,
      behavior: 'smooth',
      block: 'end',
    });
    // }, 200);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { t } = useTranslation();
  let data;
  if (props.selectedLang === 'fr') {
    data = TermsDataFr;
  } else {
    data = TermsData;
  }
  return (
    <div>
      <DeadlineScrollBar></DeadlineScrollBar>

      <Container style={{ marginTop: '80px', fontSize: '1em' }}>
        <Breadcrumbs aria-label="breadcrumb" style={{ marginTop: '78px' }}>
          <HashLink smooth to="/#footer" scroll={(el) => scrollWithOffset(el)}>
            <strong>{t('sections-TermsCondition-TermsCondition-Home')}</strong>
          </HashLink>

          <Typography color="textPrimary">
            {t('sections-TermsCondition-TermsCondition-TC')}
          </Typography>
        </Breadcrumbs>
        {data.map((data) => (
          <p style={{ fontSize: '1em' }}>
            <ReactMarkdown className="markdown" key={data.id}>
              {data.article}
            </ReactMarkdown>
          </p>
        ))}
        {/* <nav aria-label="breadcrumb" style={{ marginTop: "78px" }}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <HashLink
                smooth
                to="/#footer"
                scroll={(el) => scrollWithOffset(el)}
              >
                Home
              </HashLink>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Terms & Condition
            </li>
          </ol>
        </nav> */}
      </Container>
      <Footer></Footer>
    </div>
  );
};

export default TermsCondition;
